<template>
  <div id="wallet">
    <!-- 顶部导航栏 -->
    <van-nav-bar :title="$t('title.wallet')" placeholder safe-area-inset-top @click-left="onClickLeft" left-arrow >
      <template #right>
        <div @click="showDetails">{{ $t('column.details') }}</div>
      </template>
    </van-nav-bar>
    <van-row class="wallet">
      <!-- 总余额卡片 -->
      <van-col span="22" offset="1" class="balance-card">
        <van-col span="22" offset="1">
          <van-col span="24" class="total-label">{{ $t('column.total_names',{name: ticket_name})}}</van-col>
          <van-col span="24" class="total-amount">
            <img src="../assets/img/coin9.png"/> {{ totalBeans }}
          </van-col>
        </van-col>
        <van-col span="24" class="balance-card-bg">
          <van-col span="22" offset="1">
            <van-col span="12">
              <van-col span="24" class="balance-label">{{ $t('column.withdrawal_names',{name: ticket_name})}}</van-col>
              <van-col span="24" class="balance-value">
                <img src="../assets/img/coin9.png" />{{ withdrawalBeans }}
              </van-col>
            </van-col>
            <van-col span="12">
              <van-col span="20" class="balance-label">{{ $t('column.names_to_be_confirmed',{name: ticket_name})}}</van-col>
              <van-col span="4" class="arrow-icon">
                <van-icon name="arrow" size="12" />
              </van-col>
              <van-col span="24" class="balance-value">
                <img src="../assets/img/coin9.png" />{{ pendingBeans }}
              </van-col>
            </van-col>
          </van-col>
        </van-col>
      </van-col>
      <!-- Tab导航 -->
      <van-col span="24" class="tab-nav">
        <van-col span="6" class="tab-item" :class="{'tab-active': activeTab === 'cashout'}" @click="activeTab = 'cashout'">
          {{ $t('column.cash_out')}}
          <div class="tab-active-width" v-if="activeTab === 'cashout'"></div>
        </van-col>
        <van-col span="6" class="tab-item" :class="{'tab-active': activeTab === 'exchange'}" @click="activeTab = 'exchange'">
          {{ $t('column.exchange')}}
          <div class="tab-active-width" v-if="activeTab === 'exchange'"></div>
        </van-col>
        <van-col span="6" class="tab-item" :class="{'tab-active': activeTab === 'transfer'}" @click="activeTab = 'transfer'" v-if="is_transfer == '1'">
          {{ $t('column.Transfer')}}
          <div class="tab-active-width" v-if="activeTab === 'transfer'"></div>
        </van-col>
      </van-col>
      <!-- Exchange 页面 -->
      <van-col span="22" offset="1" v-if="activeTab === 'exchange'">
        <!-- <van-col span="24" class="exchange-options" v-if="is_coin_seller">
          <van-col span="14" offset="1" class="exchange-link">
            <img src="../assets/img/coin10.png"/>
            {{ $t('column.exchange_to_offline_coins')}}
          </van-col>
          <van-col span="8" class="go-link" @click="goToCoinSeller">
            {{ $t('column.go_to_coinseller')}} <van-icon name="arrow" size="14" color="#FF61F5"/>
          </van-col>
        </van-col> -->
        <van-col span="24" class="exchange-rate-card">
          <van-col span="22" offset="1" class="exchange-rate-card-bg">
            <van-col span="22" offset="1" class="rate-header">
              {{ $t('column.exchange_rate')}}: <img src="../assets/img/coin9.png"/> {{ exchange_rate * 100 }} = <img src="../assets/img/coin11.png"/> 100
            </van-col>
            <van-col span="22" offset="1" class="currency-row">
              <van-col span="11">
                <van-col span="24" class="currency-icon">
                  <img src="../assets/img/coin9.png"/>
                </van-col>
                <van-col span="24" class="currency-name">{{ ticket_name }}</van-col>
              </van-col>
              <van-col span="2" class="currency-row-centent">
              <img src="../assets/img/transfer_arrow1.png"/>
              </van-col>
              <van-col span="11">
                <van-col span="24" class="currency-icon">
                  <img src="../assets/img/coin10.png"/>
                </van-col>
                <van-col span="24" class="currency-name-color">{{ $t('column.offline_coins')}}</van-col>
              </van-col>
            </van-col>
          </van-col>
          <van-col span="22" offset="1" :class="is_coin_seller === 0? 'exchange-amount2':'exchange-amount'">
            <van-col span="8" class="amount-input">
              <img src="../assets/img/coin9.png"/>
              <div class="amount-input-coin"><van-field v-model="exchange_coin" @input="handleInput"/></div>
            </van-col>
            <van-col span="3" class="all-btn" @click="selectAll">{{ $t('column.all')}}</van-col>
            <van-col span="1" class="arrow-center">
              <img src="../assets/img/transfer_arrow2.png"/>
            </van-col>
            <van-col span="11" offset="1" class="result-amount">
              <img src="../assets/img/coin11.png"/> {{ exchange_diamonds }}
            </van-col>
          </van-col>
          <van-col span="22" offset="1" class="min-exchange">{{ $t('column.minimum_exchange_names',{name: ticket_name})}}: {{ exchangeAmount }}</van-col>
        </van-col>
        <van-col span="22" offset="1" class="max-exchange-times">{{ $t('column.daily_exchange_times')}}: {{ exchange_times }}</van-col>
        <van-col span="22" offset="1" class="exchange_button">
          <van-button color="#FF61F5" :disabled="exchange_coin <= 0" round block @click="exchangeBeans">{{ $t('column.exchange')}} {{ ticket_name }}</van-button>
        </van-col>
      </van-col>
      <!-- Transfer 页面 -->
      <van-col span="22" offset="1" v-if="activeTab === 'transfer'">
        <van-col span="24" class="warning-info">
          <van-icon name="info-o" size="16" />
          {{ $t('column.confirm_details_before_transacting')}}
        </van-col>
        <van-col span="24" class="transfer-desc">
          {{ $t('column.transfer_to_agency_coinseller') }}
          <span class="charge-rate">{{ transfer_service_fee * 100 }}%</span>
        </van-col>
        <van-col span="24" class="coinseller-section">
          <van-col span="16" class="section-label">{{ $t('column.coinseller_id')}}:</van-col>
          <van-col span="8" class="history-link" @click="showHistory">{{ $t('column.history')}} </van-col>
          <van-col span="20">
            <van-field v-model="transfer_user_id" class="coinseller-section-input" :placeholder="$t('column.please_input_user_id')" :border="false" />
          </van-col>
          <van-col span="4" class="check-btn" @click="checkUser">{{ $t('column.check') }}</van-col>
          <van-col span="24" v-if="transfer_user.nick_name"> {{ transfer_user.nick_name }} ({{ transfer_user.id }}) </van-col>
        </van-col>

        <van-col span="24" class="transfer-amount-section">
          <van-col span="24" class="section-title">{{ $t('column.Transfer') }}</van-col>
          <van-col span="24" class="amount-input-field">
            <img src="../assets/img/coin9.png"/>
            <div class="amount-input-field-coin"><van-field v-model="transferCoin" @input="transferInput" :placeholder="$t('column.please_enter_multiple_of',{coin: transferAmount})" :border="false"/></div>
          </van-col>

          <van-col span="24">
            <van-col span="24" class="fee-label">
              {{ $t('column.service_fee')}}: <img src="../assets/img/coin9.png"/> {{ transfer_service_fee_coin }}
            </van-col>
<!--            <van-col span="12" class="fee-info">-->
<!--              <van-icon name="info-o" color="#999999" size="16" />-->
<!--            </van-col>-->
          </van-col>
          <van-col span="24" class="received-amount">
            {{ $t('column.received')}}:  <img src="../assets/img/coin9.png"/> {{ transfer_received_coin }}
          </van-col>
          <van-col span="24" class="daily-limit">{{ $t('column.daily_transfer_times')}}: {{ transfer_times }}</van-col>
        </van-col>
        <van-col span="22" offset="1" class="transfer-btn">
          <van-button color="#FF61F5" :disabled="transferAmount <= 0" round block @click="transferBeans">{{ $t('column.Transfer')}} <img src="../assets/img/coin9.png"/> {{ transferCoin }}</van-button>
        </van-col>
      </van-col>

      <!-- Cash out 页面 -->
      <van-col span="22" offset="1" v-if="activeTab === 'cashout'">
        <van-col span="24" class="currency-type-section">
          <van-col span="12" offset="1">
            <van-col span="24" class="currency-type-section-name">
              {{ $t('column.currency_type')}} <van-icon name="question-o" size="14" color="#5E5D65" />
            </van-col>
          </van-col>
          <van-col span="10" class="section-value" @click.native="CurrencyTypeShow = true">
            <img :src="currency_list[currency_type_id].country_img" v-if="currency_list[currency_type_id]"/>  {{ currency_list[currency_type_id] ? currency_list[currency_type_id].currency_name : '' }} <van-icon name="arrow" size="14" color="#5E5D65" />
          </van-col>
        </van-col>

        <van-col span="24" class="payment-method-section">
          <van-col span="12" offset="1">
            <van-col span="24" class="currency-type-section-name">{{ $t('column.payment_method')}}</van-col>
          </van-col>
          <van-col span="10" class="section-value" @click="showPaymentTypeSelector">
            {{ payment_method_list && payment_method_list[currency_payment_id] ? payment_method_list[currency_payment_id].name : '' }} <van-icon name="arrow" size="14" color="#5E5D65" />
          </van-col>
          <van-col span="22" offset="1" class="payment-method-section-desc" v-if="payment_method_list[currency_payment_id]">
            <van-col span="12" class="payment-method-section-desc-name">{{ payment_method_list[currency_payment_id].name }}</van-col>
            <van-col span="12" class="payment-method-section-desc-img"><img :src="payment_method_list[currency_payment_id].img"/> </van-col>
            <van-col span="24" class="payment-method-section-desc-centent">
              {{ $t('column.fee')}}:{{ payment_method_list[currency_payment_id].fee_description }} <span>{{ ticket_name }}-{{ payment_method_list[currency_payment_id].is_official === '1' ? $t('column.offline') : $t('column.seller') }}</span>
            </van-col>
          </van-col>
        </van-col>

        <van-col span="24" class="payment-method-section" v-if="payment_method_list[currency_payment_id] && payment_method_list[currency_payment_id].is_official !=='1'">
          <van-col span="12" offset="1">
            <van-col span="24" class="currency-type-section-name">{{ $t('column.withdraw_payroll') }}</van-col>
          </van-col>
          <van-col span="10" class="section-value" @click="showUserPaymentSelector">
            {{ selectedPayment }} <van-icon name="arrow" size="14" color="#5E5D65" />
          </van-col>
          <van-col span="22" offset="1" class="payment-method-section-desc" v-if="currency_user_list && currency_user_list[currency_user_id]">
            <van-col span="4" class="payment-method-section-desc-avatar">
              <van-image round width="12vw" height="12vw" :src="currency_user_list[currency_user_id].head_image" fit="cover" />
            </van-col>
            <van-col span="20">
              <van-col span="24" class="payment-method-section-desc-user-name"> {{ currency_user_list[currency_user_id].nick_name }} </van-col>
              <van-col span="24" class="payment-method-section-desc-user-id">ID: {{ currency_user_list[currency_user_id].user_id }}</van-col>
            </van-col>
          </van-col>
        </van-col>

        <van-col span="24" class="cashout-amount-section"  v-if="payment_method_list[currency_payment_id]">
         <van-col span="22" offset="1">
           <van-col span="24" class="cashout-title">
             {{ $t('column.cash_out') }}
             <div class="cashout-title-border"></div>
           </van-col>
           <van-col span="24" class="amount-desc">{{ $t('column.bean_amount_cashing_out') }}</van-col>
           <van-col span="20" class="amount-input-row">
             <img src="../assets/img/coin9.png"/>
             <van-field v-model="cashoutAmount" type="digit" :placeholder="$t('column.please_enter')" :error-message="cashoutAmountMessage" :border="false" @input="cashoutAmountInput"/>
           </van-col>
           <van-col span="4" class="all-option" @click="selectAllCashout">{{ $t('column.all') }}</van-col>
           <van-col span="24" class="amount-conversion">
             <van-col span="10">{{ payment_method_list[currency_payment_id] ? payment_method_list[currency_payment_id].currency_name : '' }}:{{ cashout.credited }}</van-col>
             <van-col span="14" class="conversion-item">{{ payment_method_list[currency_payment_id] ? payment_method_list[currency_payment_id].currency_rate : '' }}{{ payment_method_list[currency_payment_id] ? payment_method_list[currency_payment_id].currency_code : '' }} = 1$ = {{ one_dollar_ticket }} {{ ticket_name }}</van-col>
           </van-col>
         </van-col>
        </van-col>

        <van-col span="24" class="account-info-section"  v-if="payment_method_list[currency_payment_id]">
          <van-col span="22" offset="1">
            <van-col span="24" class="account-title">{{ $t('column.account_information') }}</van-col>
            <van-col span="24" v-for="a in cashout.AddressJson" :key="a.id">
              <van-col span="24" class="field-label">{{ a.name }}</van-col>
              <van-col span="24" class="field-input">
                <van-field v-model="a.value" :placeholder="a.name" :border="false" />
              </van-col>
            </van-col>
          </van-col>
        </van-col>
        
        <!-- 提现限制提示 -->
        <!-- <van-col span="22" offset="1" class="withdrawal-limits" v-if="payment_method_list[currency_payment_id] && (payment_method_list[currency_payment_id].min_withdrawal > 0 || payment_method_list[currency_payment_id].max_withdrawal > 0)">
          <van-col span="24" style="font-size: 12px; color: #999; margin-top: 10px;">
            <van-icon name="info-o" size="14" />
            <span style="margin-left: 5px;">
              <span v-if="payment_method_list[currency_payment_id].min_withdrawal > 0">
                最少提现：{{ payment_method_list[currency_payment_id].min_withdrawal }} {{ ticket_name }}
              </span>
              <span v-if="payment_method_list[currency_payment_id].min_withdrawal > 0 && payment_method_list[currency_payment_id].max_withdrawal > 0">，</span>
              <span v-if="payment_method_list[currency_payment_id].max_withdrawal > 0">
                最多提现：{{ payment_method_list[currency_payment_id].max_withdrawal }} {{ ticket_name }}
              </span>
            </span>
          </van-col>
        </van-col> -->
        <van-col span="24" class="fee-rules-section" v-if="currentFeeType > 0">
          <van-col span="24">
            <van-col span="22" offset="1" class="fee-rules-title">
              {{ $t('wallet.withdrawal_rules') }}
            </van-col>
            <van-col span="24" class="withdrawal-limits" v-if="payment_method_list[currency_payment_id]">
              <van-col span="24" class="withdrawal-limits-card">
                <!-- 汇率 -->
                <van-col span="24" class="withdrawal-rule-row">
                  <van-col span="12" class="withdrawal-rule-label">
                    {{ $t('wallet.exchange_ratio') }}
                  </van-col>
                  <van-col span="12" class="withdrawal-rule-value">
                    <img src="../assets/img/coin9.png" class="coin-icon-small"/> {{ payment_method_list[currency_payment_id].currency_rate * 10000 || 0 }} = {{ payment_method_list[currency_payment_id].currency_name || '' }} 1
                  </van-col>
                </van-col>
                
                <!-- 最小提现金额 -->
                <van-col span="24" class="withdrawal-rule-row" v-if="payment_method_list[currency_payment_id].min_withdrawal > 0">
                  <van-col span="12" class="withdrawal-rule-label">
                    {{ $t('wallet.min_withdrawal_amount') }}
                  </van-col>
                  <van-col span="12" class="withdrawal-rule-value">
                    ${{ payment_method_list[currency_payment_id].min_withdrawal }}
                  </van-col>
                </van-col>
                
                <!-- 最大提现金额 -->
                <van-col span="24" class="withdrawal-rule-row" v-if="payment_method_list[currency_payment_id].max_withdrawal > 0">
                  <van-col span="12" class="withdrawal-rule-label">
                    {{ $t('wallet.max_withdrawal_amount') }}
                  </van-col>
                  <van-col span="12" class="withdrawal-rule-value">
                    ${{ payment_method_list[currency_payment_id].max_withdrawal }}
                  </van-col>
                </van-col>
              </van-col>
            </van-col>
            <!-- 底部说明 -->
            <van-col span="24" class="fee-rules-note">
              <van-col span="24">{{ $t('wallet.rule_note_1') }}</van-col>
              <van-col span="24">{{ $t('wallet.rule_note_2') }} </van-col>
              <van-col span="24" v-if="currentFeeType == 2">{{ $t('wallet.rule_note_3', {count: monthly_withdrawal_count}) }} </van-col>
            </van-col>
          
            <!-- 按金额阶梯 -->
            <van-col span="24" v-if="currentFeeType == 1">
              <van-col span="24" class="withdrawal-limits-card">
                <van-col span="24" class="withdrawal-rule-row">
                  <van-col span="12" class="withdrawal-rule-label">
                    {{ $t('wallet.withdrawal_amount') }}
                  </van-col>
                  <van-col span="12" class="withdrawal-rule-value">
                    {{ $t('wallet.service_fee') }}
                  </van-col>
                </van-col>
                <van-col span="24" class="withdrawal-rule-row" v-for="(tier, index) in currentFeeTiers" :key="index">
                  <van-col span="12" class="withdrawal-rule-label">
                    {{ (tier.min_amount || 0).toLocaleString() }} ≤ <img src="../assets/img/coin9.png" class="coin-icon-small"/> ≤ {{ (tier.max_amount || 0).toLocaleString() }}
                  </van-col>
                  <van-col span="12" class="withdrawal-rule-value">
                    <span class="fee-rule-amount">
                      {{ ((tier.fee_rate || 0) * 100).toFixed(2) }}%
                    </span>
                  </van-col>
                </van-col>
              </van-col>
            </van-col>
            
            <!-- 按次数阶梯 -->
            <van-col span="24" v-if="currentFeeType == 2">
              <van-col span="24" class="withdrawal-limits-card">
                <van-col span="24" class="withdrawal-rule-row">
                  <van-col span="12" class="withdrawal-rule-label">
                    {{ $t('wallet.monthly_withdrawal_count') }}
                  </van-col>
                  <van-col span="12" class="withdrawal-rule-value">
                    {{ $t('wallet.service_fee') }}
                  </van-col>
                </van-col>
                <van-col span="24" class="withdrawal-rule-row" v-for="(tier, index) in currentFeeTiers" :key="index">
                  <van-col span="12" class="withdrawal-rule-label">
                    {{ $t('wallet.times_range', {min: tier.min_times || 0, max: tier.max_times || 0}) }}
                  </van-col>
                  <van-col span="12" class="withdrawal-rule-value">
                    <span class="fee-rule-amount">
                      {{ ((tier.fee_rate || 0) * 100).toFixed(2) }}%
                    </span>
                  </van-col>
                </van-col>
              </van-col>
            </van-col>
          </van-col>
        </van-col>
        
        <van-col span="22" offset="1" class="withdraw-btn" v-if="payment_method_list[currency_payment_id]">
          <van-button color="#FF61F5" round block @click="ConfirmWithdrawalInformationShow = true">{{ $t('btn.Withdrawal')}}</van-button>
        </van-col>
      </van-col>

      <van-popup v-model="ExchangeCoinShow" position="bottom" closeable :style="{ paddingBottom: '8vw' }" round >
        <van-col span="24" class="wallet_exchange_popup_title"> {{ $t('column.confirm_exchange') }}</van-col>
        <van-col span="22" offset="1" class="wallet_exchange_popup_centent">
          <van-col span="11">
            <van-col span="24" class="wallet_exchange_popup_centent_left_img"> <img src="../assets/img/coin9.png"/> </van-col>
            <van-col span="24" class="wallet_exchange_popup_centent_left_coin">{{ exchange_coin }}</van-col>
            <van-col span="24" class="wallet_exchange_popup_centent_left_name"> {{ ticket_name }}</van-col>
          </van-col>
          <van-col span="2" class="wallet_exchange_popup_centent_centent">
            <img src="../assets/img/left_jiantou.png"/>
          </van-col>
          <van-col span="11">
            <van-col span="24" class="wallet_exchange_popup_centent_left_img"> <img src="../assets/img/coin11.png"/> </van-col>
            <van-col span="24" class="wallet_exchange_popup_centent_left_coin">{{ exchange_diamonds }}</van-col>
            <van-col span="24" class="wallet_exchange_popup_centent_left_name"> {{ diamonds_name }}</van-col>
          </van-col>
        </van-col>
        <van-col span="22" offset="1" class="wallet_exchange_popup_btn">
          <van-button color="#FF61F5" round block @click="ExchangeCoinBtn">{{ $t('btn.confirm') }}</van-button>
        </van-col>
      </van-popup>
      <van-popup v-model="TransferCoinShow" position="bottom" closeable :style="{ paddingBottom: '8vw' }" round >
        <van-col span="24" class="wallet_exchange_popup_title"> {{ $t('column.transfer_details') }}</van-col>
        <van-col span="22" offset="1" class="wallet_exchange_popup_centent">
          <van-col span="22" offset="1" class="wallet_transfer_popup_type">
            <van-col span="8" class="wallet_transfer_popup_type_title"> {{ $t('column.exchanger')}} </van-col>
            <van-col span="16" class="wallet_transfer_popup_type_centent" v-if="transfer_user.nick_name">
              {{ transfer_user.nick_name }} ({{ transfer_user.id }}) <span v-if="transfer_user.type_text">{{ transfer_user.type_text }}</span>
            </van-col>
          </van-col>
          <van-col span="22" offset="1" class="wallet_transfer_popup_type">
            <van-col span="12" class="wallet_transfer_popup_type_title">{{ $t('column.transfer_amount')}} </van-col>
            <van-col span="12" class="wallet_transfer_popup_type_centent">
              <img src="../assets/img/coin9.png"/>{{ transfer_received_coin }}
            </van-col>
          </van-col>
          <van-col span="22" offset="1" class="wallet_transfer_popup_type">
            <van-col span="12" class="wallet_transfer_popup_type_title">{{ $t('column.service_fee')}}</van-col>
            <van-col span="12" class="wallet_transfer_popup_type_centent">
              <img src="../assets/img/coin9.png"/>{{ transfer_service_fee_coin }}
            </van-col>
          </van-col>
        </van-col>
        <van-col span="22" offset="1" class="wallet_exchange_popup_btn">
          <van-button color="#FF61F5" round block @click="TransferCoinBtn">{{ $t('column.transfer_now') }}</van-button>
        </van-col>
      </van-popup>
      <van-popup v-model="CurrencyTypeShow" position="bottom" closeable :style="{ height: '70%' }" round >
        <van-col span="24" class="currency_type_title"> {{ $t('column.currency_type')}}  </van-col>
        <van-col span="24" class="currency_type_list">
          <van-col span="22" offset="1">
            <van-cell class="currency_type_list_border" v-for="c in recommend_currency_type" :key="c.id">
              <van-index-anchor class="currency_type_index_status" index="#" />
              <van-col span="24"  class="currency_type_list_wallet_title" @click.native="CurrencyTypeSelect(c,1)">
                <img :src="c.country_img"/> {{ c.country_name }}  <van-tag color="#F7F8FB" text-color="#1A1A1A">{{ c.currency_name }}</van-tag> <van-tag color="#FEF2C2" text-color="#1A1A1A" v-if="c.is_recommend ==1">{{ $t('column.recommend') }}</van-tag>
              </van-col>
            </van-cell>
          </van-col>
          <van-index-bar :index-list="indexList">
            <van-col class="currency_type_regions" span="22" offset="1">Countries/Regions</van-col>
            <van-col span="22" offset="1" v-for="(group, index) in currency_type" :key="index">
              <van-index-anchor class="currency_type_index_status" :index="group.letter" />
              <van-cell class="currency_type_list_border" v-for="country in group.countries" :key="country.id">
                <van-col span="24"  class="currency_type_list_wallet_title"  @click.native="CurrencyTypeSelect(country,0)">
                  <img :src="country.country_img"/> {{ country.country_name }} <van-tag color="#F7F8FB" text-color="#1A1A1A">{{ country.currency_name }}</van-tag> <van-tag color="#FEF2C2" text-color="#1A1A1A" v-if="country.is_recommend ==1">{{ $t('column.recommend') }}</van-tag>
                </van-col>
              </van-cell>
            </van-col>
          </van-index-bar>
        </van-col>
      </van-popup>

      <van-popup v-model="CurrencyPaymentShow" position="bottom" closeable :style="{ paddingBottom: '3vw',paddingTop: '3vw' }" round >
        <van-col span="24" class="wallet_currency_payment_show_title"> {{ $t('column.payment_method')}}  </van-col>
        <van-col span="22" offset="1" :class="is_official_currency_payment === '1' ? 'wallet_currency_payment_show_list wallet_official' : 'wallet_currency_payment_show_list wallet_seller'">
          <van-col span="22" offset="1" class="wallet_currency_payment_show_list_title" v-if="is_official_currency_payment === '1'"> {{ $t('column.official_method')}}</van-col>
          <van-col span="22" offset="1" v-else>
           <van-col span="24" class="wallet_currency_payment_show_list_title2"> <img src="../assets/img/seller_method_title_img.png" alt=""> {{ $t('column.seller_method')}}</van-col>
            <van-col span="24" class="wallet_currency_payment_show_list_title3"> {{ $t('column.lower_fees_and_reviewed_within_24_hours')}}</van-col>
          </van-col>
          <van-col span="22" offset="1" class="wallet_currency_payment_show_list_type">
            <van-cell v-for="item in payment_method_list" :key="item.id" @click="CurrencyPaymentBtn(item)" is-link>
              <template #title>
                <span class="wallet_currency_payment_show_list_type_title">{{ item.name }}</span>
                <span class="wallet_currency_payment_show_list_type_title2">
                  <van-tag color="#F7F8FB" text-color="#1A1A1A">{{ item.currency_name }}</van-tag> 
                </span>
              </template>
              <template #default>
                <img :src="item.img" class="wallet_currency_payment_show_list_type_img" />
              </template>
              <template #label>
                <span  class="wallet_currency_payment_show_list_type_fee">
                  <van-tag color="#FFF9DB" text-color="#FFA318">
                    {{ $t('column.fee')}}:{{ item.fee_description }}
                  </van-tag>
                   
                </span>
              </template>
            </van-cell>
          </van-col>
        </van-col>
      </van-popup>
      <van-popup v-model="UserPaymentSelectorShow" position="bottom" closeable :style="{ height: '70%' }" round >
        <van-col span="24" class="wallet_currency_payment_show_title"> {{ $t('column.withdraw_payroll_list')}}  </van-col>
        <van-col span="22" offset="1" class="user_payment_selector_show_search">
          <van-search v-model="search_user_id" @search="search_user" :placeholder="$t('column.search_user_id')" />
        </van-col>
        <van-col span="22" offset="1">
          <van-list class="user_payment_selector_show_list">
            <van-cell v-for="t in search_user_list" :key="t.user_id" @click="UserPaymentSelectorBtn(t)">
              <van-col span="4" class="user_payment_selector_show_list_img">
                <img :src="t.head_image" />
              </van-col>
              <van-col span="20">
                <van-col span="24" class="user_payment_selector_show_list_name">{{ t.nick_name }}</van-col>
                <van-col span="24" class="user_payment_selector_show_list_id">ID:{{ t.user_id }}</van-col>
              </van-col>
            </van-cell>
          </van-list>
        </van-col>
      </van-popup>
      <van-popup v-model="ConfirmWithdrawalInformationShow" position="bottom" closeable round >
        <van-col span="24" class="wallet_currency_payment_show_title"> {{ $t('column.check_your_request')}} </van-col>
        <van-col span="22" offset="1">
          <van-col span="24" class="wallet_confirm_withdrawal_will">{{ $t('column.you_will_get') }}</van-col>
          <van-col span="24" class="wallet_confirm_withdrawal_will_money" v-if="payment_method_list[currency_payment_id]">{{ payment_method_list[currency_payment_id].currency_code }} {{ cashout.credited }}</van-col>
          <van-col span="24">
            <van-col span="12" class="wallet_confirm_withdrawal_amount">{{ $t('column.amount')}}</van-col>
            <van-col span="12" class="wallet_confirm_withdrawal_amount_money" v-if="payment_method_list[currency_payment_id]"> {{ payment_method_list[currency_payment_id].currency_code }} {{ cashout.credited }}</van-col>
          </van-col>
          <van-col span="24">
            <van-col span="12" class="wallet_confirm_withdrawal_amount">{{ $t('column.service_fee') }}</van-col>
            <van-col span="12" class="wallet_confirm_withdrawal_amount_money" v-if="payment_method_list[currency_payment_id]"><img src="../assets/img/coin9.png"/>{{ cashout.cashoutAmountFee }}</van-col>
          </van-col>
          <van-col span="24" class="wallet_confirm_withdrawal_account">{{ $t('column.account_information') }}</van-col>
          <van-col span="24" class="wallet_confirm_withdrawal_b" v-if="payment_method_list[currency_payment_id]">
            <van-col span="12">
              <van-col span="24" class="wallet_confirm_withdrawal_payment">{{ $t('column.payment_method') }}</van-col>
              <van-col span="24" class="wallet_confirm_withdrawal_payment"><span><van-icon name="star" size="10" /> {{ ticket_name }}-{{ payment_method_list[currency_payment_id].is_official === '1' ? $t('column.offline') : $t('column.seller') }} </span></van-col>
            </van-col>
            <van-col span="12">
              <van-col span="24" class="wallet_confirm_withdrawal_payment_r">{{ payment_method_list[currency_payment_id].name }}</van-col>
              <van-col span="24" class="wallet_confirm_withdrawal_payment_r"> <img :src="payment_method_list[currency_payment_id].img"/> </van-col>
            </van-col>
          </van-col>

          <van-col span="24" v-for="a in cashout.AddressJson" :key="a.id">
            <van-col span="12" class="wallet_confirm_withdrawal_c">{{ a.name }}</van-col>
            <van-col span="12" class="wallet_confirm_withdrawal_c_r">{{ a.value }}</van-col>
          </van-col>
          <van-col span="24" class="wallet_confirm_withdrawal_btn">
            <van-button color="#FF61F5" round block @click="withdrawFunds">{{ $t('btn.Withdrawal')}}</van-button>
          </van-col>
        </van-col>
      </van-popup>
    </van-row>

  </div>
</template>

<script>

import Toast from 'vant/lib/toast'
import axios from "axios";
import {Dialog} from "vant";

export default {
  name: 'Wallet',
  filters: {
    formatMoney(value) {
      if (value === undefined || value === null) return '0'
      // 保留两位小数，去除末尾的0
      return parseFloat(value.toFixed(2)).toString()
    }
  },
  data() {
    return {
      ConfirmWithdrawalInformationShow: false,
      ExchangeCoinShow: false,
      TransferCoinShow: false,
      CurrencyTypeShow: false,
      CurrencyPaymentShow: false,
      UserPaymentSelectorShow: false,
      exchange_coin: undefined,
      exchange_diamonds: undefined,
      activeTab: 'exchange',
      ticket_name: '',
      diamonds_name: '',
      totalBeans: 0,
      withdrawalBeans: 0,
      pendingBeans: 0,
      exchangeAmount: 0,
      exchange_times: 0,
      exchange_rate: 0,
      transfer_service_fee: 0,
      transfer_service_fee_coin: undefined,
      transfer_received_coin: undefined,
      transferCoin: undefined,
      transferAmount: '',
      transfer_times: 0,
      selectedCurrency: '',
      selectedPayment: 'Select',
      cashoutAmount: '',
      is_coin_seller: 0,
      transfer_user: {
        nick_name: undefined,
        type_text: undefined,
        type: 1 // 1机构 2币商
      },
      transfer_user_id: undefined,
      currency_type: [],
      indexList: [],
      recommend_currency_type: [],
      currency_list: [],
      payment_method_list:[],
      currency_type_id: 0,
      currency_payment_id: 0,
      cashout: {
        credited:0,
        cashoutAmountFee:0,
        AddressJson: null,
      },
      is_official_currency_payment: 0,
      currency_user_list: [],
      currency_user_id: 0,
      search_user_list: [],
      search_user_id: undefined,
      one_dollar_ticket: 0,
      ticket_catty_ratio: 0,
      withdraw_ticket_multiple: 0,
      cashoutAmountMessage: '',
      is_transfer: 0,
      monthly_withdrawal_count: 0, // 🆕 本月已提现次数
    }
  },
  created() {
    this.get_list()
  },
  computed: {
    // 🆕 新增
    currentFeeType() {
      if (this.payment_method_list && this.payment_method_list[this.currency_payment_id]) {
        return this.payment_method_list[this.currency_payment_id].fee_type || 0
      }
      return 0
    },
    currentFeeTiers() {
      console.log('currentFeeTiers')
      if (this.payment_method_list && this.payment_method_list[this.currency_payment_id]) {
        const feeTiers = this.payment_method_list[this.currency_payment_id].fee_tiers
        console.log('fee_tiers raw:', feeTiers)
        console.log('fee_tiers type:', typeof feeTiers)
        console.log('fee_tiers length:', Array.isArray(feeTiers) ? feeTiers.length : 'not array')
        
        // 确保返回的是数组
        if (Array.isArray(feeTiers)) {
          return feeTiers
        }
        
        // 如果是字符串，尝试解析
        if (typeof feeTiers === 'string') {
          try {
            const parsed = JSON.parse(feeTiers)
            console.log('fee_tiers parsed:', parsed)
            return Array.isArray(parsed) ? parsed : []
          } catch (e) {
            console.error('fee_tiers parse error:', e)
            return []
          }
        }
        
        return []
      }
      return []
    }
  },
  methods: {
    // 🆕 新增：获取本月提现次数
    getMonthlyWithdrawalCount() {
      // 调用API获取本月提现次数
       const uid = this.$route.query.uid
      const token = this.$route.query.token
       axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=wallet&act=get_monthly_withdrawal_count",{
        params:{uid: uid, token: token }
      }).then(res =>{
         if (res.data.code === 200) {
          this.monthly_withdrawal_count = res.data.data.count || 0
        }
      }).catch(err => {
        console.error('获取本月提现次数失败:', err)
      })
    },
    cashoutAmountInput() {
      this.cashoutAmountMessage = ''
      this.cashout.credited = 0
      this.cashout.cashoutAmountFee = 0
      let rate = 0
      let fee = 0
      let feeFixed = 0
      
      if (this.payment_method_list && this.payment_method_list[this.currency_payment_id]) {
        rate = this.payment_method_list[this.currency_payment_id].currency_rate
        const paymentMethod = this.payment_method_list[this.currency_payment_id]
        const feeType = paymentMethod.fee_type || 0
        
        if (feeType == 1) {
          // 🆕 按金额阶梯
          let feeTiers = paymentMethod.fee_tiers || []
          // fee_tiers 可能是 JSON 字符串，需要解析
          if (typeof feeTiers === 'string') {
            try {
              feeTiers = JSON.parse(feeTiers)
            } catch (e) {
              console.error('解析 fee_tiers 失败:', e)
              feeTiers = []
            }
          }
          console.log('解析后的 feeTiers:', feeTiers)
          for (let i = 0; i < feeTiers.length; i++) {
            const tier = feeTiers[i]
            console.log('检查阶梯:', tier.min_amount, '-', tier.max_amount, '费率:', tier.fee_rate)
            if (this.cashoutAmount >= tier.min_amount && this.cashoutAmount <= tier.max_amount) {
              fee = parseFloat(tier.fee_rate)
              feeFixed = parseInt(tier.fee_fixed) || 0
              console.log('匹配成功，费率:', fee, '固定费用:', feeFixed)
              break
            }
          }
        } else if (feeType == 2) {
          // 🆕 按次数阶梯 - 使用本月提现次数（本次是第几次）
          const withdrawalTimes = (this.monthly_withdrawal_count || 0) + 1
          let feeTiers = paymentMethod.fee_tiers || []
          // fee_tiers 可能是 JSON 字符串，需要解析
          if (typeof feeTiers === 'string') {
            try {
              feeTiers = JSON.parse(feeTiers)
            } catch (e) {
              console.error('解析 fee_tiers 失败:', e)
              feeTiers = []
            }
          }
          for (let i = 0; i < feeTiers.length; i++) {
            const tier = feeTiers[i]
            if (withdrawalTimes >= tier.min_times && withdrawalTimes <= tier.max_times) {
              fee = parseFloat(tier.fee_rate)
              feeFixed = parseInt(tier.fee_fixed) || 0
              break
            }
          }
        } else {
          // 单一费率（兼容旧数据）
          fee = parseFloat(paymentMethod.fee) || 0
        }
      }
      
      if (this.cashoutAmount > this.withdrawalBeans) {
        this.cashoutAmount = this.withdrawalBeans
      }

      if(this.cashoutAmount && rate && this.ticket_catty_ratio) {
        if (this.cashoutAmount % this.withdraw_ticket_multiple === 0) {
          let result = this.cashoutAmount * rate * this.ticket_catty_ratio
          this.cashout.credited = result.toFixed(0)
        } else {
          this.cashoutAmountMessage = this.$t('column.please_enter_multiple_of', {coin: this.withdraw_ticket_multiple})
        }
      }
      // 🆕 修改：手续费 = 提现金额 × 百分比费率 + 固定值（基于提现金额，不是转换后的金额）
      if (this.cashoutAmount && (fee > 0 || feeFixed > 0)) {
        let result1 = this.cashoutAmount * fee + feeFixed
        this.cashout.cashoutAmountFee = result1.toFixed(0)
      }
    },
    search_user() {
      if (!this.search_user_id) {
        this.search_user_list = this.currency_user_list
      }else{
        const query = this.search_user_id.toLowerCase();
        this.search_user_list =[]
        const userArray = Object.values(this.currency_user_list)
        for ( let i = 0; i < userArray.length; i++){
          const t = userArray[i]
          // 检查ID是否匹配（模糊）
          const idMatch = t.user_id.toString().toLowerCase().includes(query);
          // 如果ID或姓名匹配，则添加到结果列表
          if (idMatch) {
            this.search_user_list.push(t);
          }
        }
      }
    },
    UserPaymentSelectorBtn(t) {
      this.currency_user_id = t.user_id
      this.UserPaymentSelectorShow = false
    },
    showUserPaymentSelector() {
      const toast = this.$toast.loading({
        duration: 0, // 持续展示
        forbidClick: true,
        message: this.$t('other.Loading') + '...',
        className: 'custom-loading-toast' // 添加自定义类名
      });
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=wallet&act=payroll_seller_payment_method",{
        params:{uid: uid, token: token, payment_method_id: this.currency_payment_id }
      }).then(res =>{
        toast.clear(); // 关闭加载提示
        console.log(res.data)
        if(res.data.status===1){
          this.currency_user_list = res.data.data.list
          this.search_user()
          this.UserPaymentSelectorShow = true
        }else{
          Toast(res.data.error)
        }
      })
    },
    CurrencyTypeSelect(item,type) {

      if (type === 1){
        this.currency_type_id = item.currency_type_id * 10000
      }else{
        this.currency_type_id = item.currency_type_id
      }
      console.log(this.currency_type_id)
      console.log(this.currency_list)
      this.payment_method_list = this.currency_list[this.currency_type_id].payment_method_type
      console.log(this.payment_method_list)
      this.is_official_currency_payment  = this.currency_list[this.currency_type_id].is_official
      this.CurrencyTypeShow = false
    },
    currency_set(countries){
      // 按字母分组国家数据
      let groups = {};
      let letters =[]
      countries.forEach(country => {
        const letter = country.letter;
        if (!groups[letter]) {
          groups[letter] = [];
        }
        groups[letter].push(country);
          if (!letters.includes(letter)) {
            letters.push(letter);
          }
      });
      // 排序并添加索引
      letters.sort();
      // 字母索引列表
      this.indexList = [...letters];

      this.currency_type = Object.keys(groups).sort().map(letter => ({
        letter,
        countries: groups[letter]
      }));
      console.log(this.currency_type)
      console.log(this.indexList)
      console.log('dddddddddd')
    },
    get_list() {
      const toast = this.$toast.loading({
        duration: 0, // 持续展示
        forbidClick: true,
        message: this.$t('other.Loading') + '...',
        className: 'custom-loading-toast' // 添加自定义类名
      });
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=wallet&act=get_wallet_info",{
        params:{uid: uid, token: token, date: this.date }
      }).then(res =>{
        toast.clear(); // 关闭加载提示
        console.log(res.data)
        if(res.data.status===1){
          this.totalBeans = res.data.data.total
          this.withdrawalBeans = res.data.data.withdrawal_total
          this.pendingBeans = res.data.data.pending_total
          this.exchangeAmount = res.data.data.min_exchange
          this.transferAmount = res.data.data.transfer_multiple
          this.ticket_name = res.data.data.ticket_name
          this.diamonds_name = res.data.data.diamonds_name
          this.exchange_rate = res.data.data.exchange_rate
          this.transfer_service_fee = res.data.data.transfer_service_fee
          this.exchange_times = res.data.data.exchange_times
          this.transfer_times = res.data.data.transfer_times
          this.is_coin_seller = res.data.data.is_coin_seller
          this.recommend_currency_type = res.data.data.official_country_list
          this.currency_list = res.data.data.currency_list
          this.one_dollar_ticket = res.data.data.one_dollar_ticket
          this.ticket_catty_ratio = res.data.data.ticket_catty_ratio
          this.withdraw_ticket_multiple = res.data.data.withdraw_ticket_multiple
          this.currency_set(res.data.data.currency_type)
          this.is_transfer =  res.data.data.is_transfer
           // 🆕 新增：获取本月提现次数
          this.getMonthlyWithdrawalCount()
        }else{
          Toast(res.data.error)
        }
      })
    },
    handleInput(value) {
      // 移除非数字字符
      let newValue = value.replace(/\D/g, '');
      // 移除前导零（除非就是0）
      if (newValue.length > 1 && newValue[0] === '0') {
        newValue = newValue.replace(/^0+/, '');
      }
      // 更新输入值
      this.exchange_coin = newValue;
      if (this.exchange_rate > 0 && this.exchange_coin > 0) {
        this.exchange_diamonds = Math.floor(this.exchange_coin / this.exchange_rate);
      }else{
        this.exchange_diamonds = undefined;
      }
    },
    transferInput(value) {
      // 移除非数字字符
      let newValue = value.replace(/\D/g, '');
      // 移除前导零（除非就是0）
      if (newValue.length > 1 && newValue[0] === '0') {
        newValue = newValue.replace(/^0+/, '');
      }
      // 更新输入值
      this.transferCoin = newValue;
      if (this.transferCoin > 0) {
        this.transfer_service_fee_coin = Math.floor(this.transferCoin * this.transfer_service_fee)
        if(this.transfer_service_fee_coin > 0){
          this.transfer_received_coin = this.transferCoin - this.transfer_service_fee_coin
        }else{
          this.transfer_service_fee_coin =undefined
          this.transfer_received_coin =undefined
        }
      }else{
        this.transferCoin = undefined
        this.transfer_service_fee_coin =undefined
        this.transfer_received_coin =undefined
      }
    },
    onClickLeft() {
      // 拦截关闭h5
      window.location.href="bogolive://exit"
    },
    ExchangeCoinBtn() {
      this.ExchangeCoinShow = false
      // 兑换处理
      const toast = this.$toast.loading({
        duration: 0, // 持续展示
        forbidClick: true,
        message: this.$t('other.Loading') + '...',
        className: 'custom-loading-toast' // 添加自定义类名
      });
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=wallet&act=exchange_coin",{
        params:{uid: uid, token: token, ticket: this.exchange_coin }
      }).then(res =>{
        toast.clear(); // 关闭加载提示
        if(res.data.status===1){
          this.exchange_coin = undefined
          Toast({
            message: res.data.error,
            duration: 2000, // 持续2秒
            onClose: () => {
              // 这里写Toast关闭后要执行的方法
              this.get_list()
            }
          });
        }else{
          Toast(res.data.error)
        }
      })
    },
    TransferCoinBtn() {
      this.TransferCoinShow = false
      // 转让处理
      const toast = this.$toast.loading({
        duration: 0, // 持续展示
        forbidClick: true,
        message: this.$t('other.Loading') + '...',
        className: 'custom-loading-toast' // 添加自定义类名
      });
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=wallet&act=transfer_coin",{
        params:{uid: uid, token: token, ticket: this.transferCoin, to_uid: this.transfer_user_id }
      }).then(res =>{
        toast.clear(); // 关闭加载提示
        if(res.data.status===1){
          this.transferCoin = undefined
          this.transfer_user.nick_name = undefined
          this.transfer_user.type_text = undefined
          this.transfer_user.type = undefined
          this.transfer_service_fee_coin =undefined
          this.transfer_received_coin =undefined
          Toast({
            message: res.data.error,
            duration: 2000, // 持续2秒
            onClose: () => {
              // 这里写Toast关闭后要执行的方法
              this.get_list()
            }
          });
        }else{
          Toast(res.data.error)
        }
      })
    },
    showDetails() {
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      this.$router.push({ path: '/wallet_details', query: { uid: uid, token: token } })
    },
    goToCoinSeller() {
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      this.$router.push({ path: '/coin_seller', query: { uid: uid, token: token } })
    },
    selectAll() {
      this.exchange_coin = this.totalBeans
    },
    exchangeBeans() {
      if (this.exchange_coin < this.exchangeAmount) {
        Toast(this.$t('column.minimum_exchange_names',{name: this.ticket_name}) + ':' + this.exchangeAmount)
      }else{
        this.ExchangeCoinShow = true
      }
    },
    showHistory() {
      Toast('Transfer history')
    },
    CurrencyPaymentBtn(item){
      console.log('5566')
      console.log(item)
      this.currency_payment_id = item.id
      this.cashout.AddressJson =JSON.parse(item.address_json)
      console.log(this.cashout)
      this.currency_user_id = 0
      this.currency_user_list = []
      this.is_official_currency_payment = item.is_official + ''
      this.CurrencyPaymentShow = false
    },
    checkUser() {
      const toast = this.$toast.loading({
        duration: 0, // 持续展示
        forbidClick: true,
        message: this.$t('other.Loading') + '...',
        className: 'custom-loading-toast' // 添加自定义类名
      });
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=wallet&act=get_transfer_user_info",{
        params:{uid: uid, token: token, to_uid: this.transfer_user_id }
      }).then(res =>{
        toast.clear(); // 关闭加载提示
        if(res.data.status===1){
          this.transfer_user = res.data.data
        }else{
          Toast(res.data.error)
        }
      })
    },
    transferBeans() {
     this.TransferCoinShow = true
    },
    showPaymentTypeSelector() {
      this.currency_payment_id = 0
      this.currency_user_id = 0
      this.currency_user_list = []
      this.CurrencyPaymentShow = true
    },
    selectAllCashout() {
      this.cashoutAmount = this.withdrawalBeans
    },
    withdrawFunds() {
      Dialog.confirm({
        title: this.$t('column.are_you_sure_withdraw'),
        confirmButtonColor: '#FF61F5',
        confirmButtonText: this.$t('btn.confirm'),
        cancelButtonText: this.$t('btn.cancel'),
      }).then(() => {
        const toast = this.$toast.loading({
          duration: 0, // 持续展示
          forbidClick: true,
          message: this.$t('other.Loading') + '...',
          className: 'custom-loading-toast' // 添加自定义类名
        });
        const uid = this.$route.query.uid
        const token = this.$route.query.token
// 1. 转为 JSON 字符串
        const jsonStr = JSON.stringify(this.cashout.AddressJson);
// 2. 编码特殊字符
        const encodedStr = encodeURIComponent(jsonStr);
        axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=wallet&act=withdrawal_request",{
          params:{
            uid: uid,
            token: token,
            currency_user_id: this.currency_user_id,
            payment_method_id: this.currency_payment_id,
            ticket: this.cashoutAmount,
            AddressJson: encodedStr
          }
        }).then(res =>{
          toast.clear(); // 关闭加载提示
          console.log(res.data)
          this.ConfirmWithdrawalInformationShow = false
          if(res.data.status ===1){
            this.cashoutAmount = undefined
            this.cashout.AddressJson = undefined
            this.currency_user_id = 0
            this.currency_payment_id = 0
            Toast({
              message: res.data.error,
              duration: 2000, // 持续2秒
              onClose: () => {
                // 这里写Toast关闭后要执行的方法
                this.get_list()
              }
            });
          }else{
            Toast(res.data.error)
          }
        })
      })
    }
  }
}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/wallet.vue